import { DiscographyImages } from "./Images";

export const tienesElControl = [
  {
    id: 1,
    nameAlbum: "Tienes El Control",
    year: "2023",
    totalSongs: "14",
    image: DiscographyImages.TienesElControl,
    urlMultitrack: "https://bfan.link/Tienes-El-Control1",
    songs: [
      {
        title: "Hay fiesta",
        tono: "Tono: A",
        compas: "Compas: 4/4",
        tempo: "Tempo: 128 bpm",
        urlYoutube:
          "https://www.youtube.com/embed/M4rvX7S3LEE?si=Tc94y2P0oqiRiCOR",
        pdf: "https://iglesia-web.s3.us-west-2.amazonaws.com/SPM/Tienes+el+control/1-hay-fiesta.pdf",
      },
      {
        title: "Más de ti",
        tono: "Tono: A",
        compas: "Compas: 4/4",
        tempo: "Tempo: 90 bpm",
        urlYoutube:
          "https://www.youtube.com/embed/XwrW2QDvzJU?si=IL_o7L0TOhinCg8E",
        pdf: "https://iglesia-web.s3.us-west-2.amazonaws.com/SPM/Tienes+el+control/2-mas-de-ti.pdf",
      },
      {
        title: "Profundamente te amo",
        tono: "Tono: E",
        compas: "Compas: 4/4",
        tempo: "Tempo: 70 bpm",
        urlYoutube:
          "https://www.youtube.com/embed/dNfM7SGRNpA?si=3gLWEOD5awqtoag8",
        pdf: "https://iglesia-web.s3.us-west-2.amazonaws.com/SPM/Tienes+el+control/3-profundamente-te-amo.pdf",
      },
      {
        title: "Lo tengo todo en ti",
        tono: "Tono: D",
        compas: "Compas: 6/8",
        tempo: "Tempo: 156 bpm",
        urlYoutube:
          "https://www.youtube.com/embed/HqXsbZeaXYg?si=sFoTGuaXveyHzGq3",
        pdf: "https://iglesia-web.s3.us-west-2.amazonaws.com/SPM/Tienes+el+control/4-lo-tengo-todo-en-ti.pdf",
      },
      {
        title: "Tienes el control",
        tono: "Tono: C",
        compas: "Compas: 4/4",
        tempo: "Tempo: 72 bpm",
        urlYoutube:
          "https://www.youtube.com/embed/PX8eoO2noCk?si=JlwUj3suQTCesWlg",
        pdf: "https://iglesia-web.s3.us-west-2.amazonaws.com/SPM/Tienes+el+control/5-tienes-el-control.pdf",
      },
      {
        title: "Grande como el cielo",
        tono: "Tono: C",
        compas: "Compas: 4/4",
        tempo: "Tempo: 128 bpm",
        urlYoutube:
          "https://www.youtube.com/embed/1NfMiWmqK34?si=Fh3I90fCP5hGbBh2",
        pdf: "https://iglesia-web.s3.us-west-2.amazonaws.com/SPM/Tienes+el+control/6-grande-como-el-cielo.pdf",
      },
      {
        title: "Te veré",
        tono: "Tono: Db",
        compas: "Compas: 4/4",
        tempo: "Tempo: 86 bpm",
        urlYoutube:
          "https://www.youtube.com/embed/xfJVshCiRGA?si=OE6yCYv93QgtX6CL",
        pdf: "https://iglesia-web.s3.us-west-2.amazonaws.com/SPM/Tienes+el+control/7-te-vere.pdf",
      },
      {
        title: "Tu rostro",
        tono: "Tono: G",
        compas: "Compas: 4/4",
        tempo: "Tempo: 76 bpm",
        urlYoutube:
          "https://www.youtube.com/embed/cS4KRK8Ycy4?si=CmTkz899otwQ01rj",
        pdf: "https://iglesia-web.s3.us-west-2.amazonaws.com/SPM/Tienes+el+control/8-tu-rostro.pdf",
      },
      {
        title: "Hijo de Dios",
        tono: "Tono: G",
        compas: "Compas: 6/8",
        tempo: "Tempo: 148 bpm",
        urlYoutube:
          "https://www.youtube.com/embed/nwLVO2Of5KY?si=a-nzkO4Zl-5y3EjG",
        pdf: "https://iglesia-web.s3.us-west-2.amazonaws.com/SPM/Tienes+el+control/9-hijo-de-dios.pdf",
      },
      {
        title: "Te siento en mi ser",
        tono: "Tono: D",
        compas: "Compas: 4/4",
        tempo: "Tempo: 128 bpm",
        urlYoutube:
          "https://www.youtube.com/embed/DPmSiYTFij4?si=1yjaxbQ-b4ZbCPED",
        pdf: "https://iglesia-web.s3.us-west-2.amazonaws.com/SPM/Tienes+el+control/10-te-siento-en-mi-ser.pdf",
      },
      {
        title: "Despierta",
        tono: "Tono: F",
        compas: "Compas: 4/4",
        tempo: "Tempo: 90 bpm",
        urlYoutube:
          "https://www.youtube.com/embed/1hU-u2NbRnM?si=f4TPXyP58ih7DnyD",
        pdf: "https://iglesia-web.s3.us-west-2.amazonaws.com/SPM/Tienes+el+control/11-despierta.pdf",
      },
      {
        title: "Venga tu reino",
        tono: "Tono: Db",
        compas: "Compas: 6/8",
        tempo: "Tempo: 160 bpm",
        urlYoutube:
          "https://www.youtube.com/embed/RgZQiXujo-0?si=CP_tVMDpBxs_bcZb",
        pdf: "https://iglesia-web.s3.us-west-2.amazonaws.com/SPM/Tienes+el+control/12-venga-tu-reino.pdf",
      },
      {
        title: "Reflejo de tu gloria",
        tono: "Tono: F-F#",
        compas: "Compas: 6/8",
        tempo: "Tempo: 154 bpm",
        urlYoutube:
          "https://www.youtube.com/embed/rHwFWst9gWU?si=OScAY-5VUHtxNvF6",
        pdf: "https://iglesia-web.s3.us-west-2.amazonaws.com/SPM/Tienes+el+control/13-reflejo-de-tu-gloria.pdf",
      },
      {
        title: "Tú estás aquí",
        tono: "Tono: F",
        compas: "Compas: 4/4",
        tempo: "Tempo: 135 bpm",
        urlYoutube:
          "https://www.youtube.com/embed/HhYFcONZj-k?si=rsJLRVViV88QPFdj",
        pdf: "https://iglesia-web.s3.us-west-2.amazonaws.com/SPM/Tienes+el+control/14-tu-estas-aqui.pdf",
      },
    ],
  },
  {
    id: 2,
    nameAlbum: "ADORA 24/7",
    year: "2023",
    totalSongs: "23",
    image: DiscographyImages.Adora247,
    songs: [
      {
        title: "La Bondad De Dios - Goodness Of God",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/iMlMY0SMyOQ?si=D-UtsNbGLDa_Ksrx",
        pdf: null,
      },
      {
        title: "Me Acerco Una Vez Más - Draw Close Again",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/mUD29uSy350?si=H7eNipBgseZGRbYv",
        pdf: null,
      },
      {
        title: "Me Refugio - Shelter In",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/dejOSSrie2I?si=ukxAYdTrGOaXrKPa",
        pdf: null,
      },
      {
        title: "Mi Esperanza Está En Jesús - Living Hope",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/SmWHpX5c0R8?si=_DHHzuDCMaZiiCTo",
        pdf: null,
      },
      {
        title: "Mi Gran Deseo - One Desire",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/gdduDYUArHY?si=q8QDI_O3JKWy9sLM",
        pdf: null,
      },
      {
        title: "No has perdido - Never lost",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/mFsI_uTC7-U?si=iExxozlzq6k7_J5H",
        pdf: null,
      },
      {
        title: "Rey de reyes - King of Kings",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/XCx_VW5XfkY?si=rcfxTEZXFpfOoumb",
        pdf: null,
      },
      {
        title: "Tu poder / Lo harás otra vez - Famous For + Do It Again",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/oJYosSPmB9A?si=GAaOlzIbpZg2sRRa",
        pdf: null,
      },
      {
        title: "Ver la victoria - see a victory",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/H5fUzKGj-3I?si=pv3tqxyBfsKyR93o",
        pdf: null,
      },
      {
        title: "Viento Fresco - Fresh Wind",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/_J_7F_gOuac?si=CzQOMO9YLIBl3qUm",
        pdf: null,
      },
      {
        title: "Abres camino - way maker",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/RJ-IMhpLZTY?si=WtKwyWP6w-zIiuuV",
        pdf: null,
      },
      {
        title: "Disco 2",
      },
      {
        title: "Atmósfera electrizante - electric atmosphere",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/Vxl-_r5N6vA?si=oBPg1hs8fOv3h1Vi",
        pdf: null,
      },
      {
        title: "Cadenas Romper - Break Every Chain",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/gy5C2oH_jgw?si=JL0v-qF4iK1D8Vds",
        pdf: null,
      },
      {
        title: "Cómo no voy a creer - too good to not believe",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/5_PjQ0Br8fc?si=bYoZumvUqPhURFNY",
        pdf: null,
      },
      {
        title: "El poder de tu amor - the power of your love",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/fT5C_45oYbU?si=_y5fgxK6kCZ77mrC",
        pdf: null,
      },
      {
        title: "En el altar - all on the altar",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/kYiU8guKlkQ?si=kSRfUUwFPlc5mQgP",
        pdf: null,
      },
      {
        title: "En el trono estás - God is on the throne",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/tDx0PEYMPq0?si=M11gudl3cx0xpFxR",
        pdf: null,
      },
      {
        title: "Entre las llamas - another in the fire",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/z3BBbVyuapA?si=TOz2MLr9xtGCQQeP",
        pdf: null,
      },
      {
        title: "Indescriptible - Indescribable",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/r_UeYIv6beo?si=u2NpQgQrO1WtnfcP",
        pdf: null,
      },
      {
        title: "Jesucristo basta",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/ukNJ11VWX9c?si=m9FKW-si4XYh0Yq8",
        pdf: null,
      },
      {
        title: "Jireh",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/Q7Gq3Bj0RGA?si=OuEOOuYbRML09mXt",
        pdf: null,
      },
      {
        title: "La bendición - The blessing",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/lZcaLXOpVzM?si=s3gn81tJB304PZ2b",
        pdf: null,
      },
      {
        title: "La bondad de Dios - Goodness Of God",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/iMlMY0SMyOQ?si=QPC0DlotJMxg6fL7",
        pdf: null,
      },
    ],
  },
  {
    id: 3,
    nameAlbum: "Navidad, Vol.4 (Jesús es el motivo)",
    year: "2022",
    totalSongs: "18",
    image: DiscographyImages.NavidadVol4,
    urlMultitrack: "https://bfan.link/NAVIDAD-vol-4",
    songs: [
      {
        title: "Ángeles cantando están",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube: null,
        pdf: null,
      },
      {
        title: "Hosanna - Nació el salvador",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube: null,
        pdf: null,
      },
      {
        title: "Una noche sin igual",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube: null,
        pdf: null,
      },
      {
        title: "Al mundo paz (Soul)",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube: null,
        pdf: null,
      },
      {
        title: "Emanuel",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube: null,
        pdf: null,
      },
      {
        title: "Gloria (Ángeles cantando están)",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube: null,
        pdf: null,
      },
      {
        title: "Jesús Nació",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube: null,
        pdf: null,
      },
      {
        title: "La tierra canta",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube: null,
        pdf: null,
      },
      {
        title: "Tú eres la luz noche de paz (Bonus track) [live]",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube: null,
        pdf: null,
      },
      {
        title: "Tu dejaste tu trono",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube: null,
        pdf: null,
      },
      {
        title: "Al mundo paz",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube: null,
        pdf: null,
      },
      {
        title: "Oh noche santa",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube: null,
        pdf: null,
      },
      {
        title: "Aleluya",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube: null,
        pdf: null,
      },
      {
        title: "Venid fieles todos (Bonus track) [Live]",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube: null,
        pdf: null,
      },
      {
        title: "Se oye un canto en alta esfera (Bonus track) [live]",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube: null,
        pdf: null,
      },
      {
        title: "Bienvenido",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube: null,
        pdf: null,
      },
      {
        title: "Todo va a estar bien",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube: null,
        pdf: null,
      },
      {
        title: "Todo brilla",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube: null,
        pdf: null,
      },
    ],
  },
  {
    id: 4,
    nameAlbum: "Jesús (Track by track commentary)",
    year: "2021",
    totalSongs: "14",
    image: DiscographyImages.JesusTrackByCommentary,
    urlMultitrack: null,
    songs: [
      {
        title: "Hay que celebrar (Commentary)",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube: null,
        pdf: null,
      },
      {
        title: "Salmo 91 (Commentary)",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube: null,
        pdf: null,
      },
      {
        title: "La pesadilla (Commentary)",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube: null,
        pdf: null,
      },
      {
        title: "Pienso en ti (Commentary)",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube: null,
        pdf: null,
      },
      {
        title: "Llegaste a mí (Commentary)",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube: null,
        pdf: null,
      },
      {
        title: "Gracias, Dios (Commentary)",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube: null,
        pdf: null,
      },
      {
        title: "La luz (Commentary)",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube: null,
        pdf: null,
      },
      {
        title: "Derrama tu fuego (Commentary)",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube: null,
        pdf: null,
      },
      {
        title: "Jesús (Commentary)",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube: null,
        pdf: null,
      },
      {
        title: "Disgno eres tú (Commentary)",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube: null,
        pdf: null,
      },
      {
        title: "Baila a mi lado (Commentary)",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube: null,
        pdf: null,
      },
      {
        title: "No me rindo (Commentary)",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube: null,
        pdf: null,
      },
      {
        title: "No me dejarás (Commentary)",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube: null,
        pdf: null,
      },
      {
        title: "La batería (Commentary)",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube: null,
        pdf: null,
      },
    ],
  },
  {
    id: 5,
    nameAlbum: "Jesús",
    year: "2021",
    totalSongs: "15",
    image: DiscographyImages.Jesus,
    urlMultitrack: "https://bfan.link/jesus",
    songs: [
      {
        title: "Hay que celebrar",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/mgb-6R63ET0?si=aKBus3tfsLjB5BlK",
        pdf: null,
      },
      {
        title: "Salmo 91",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/58-lgAG2Xo4?si=GZUl4NCFx9XviWb_",
        pdf: null,
      },
      {
        title: "La pesadilla",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/nPf8WXdb5cE?si=YIdiNLNYg5AgvP1o",
        pdf: null,
      },
      {
        title: "Pienso en ti",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/9nDOARGV3QE?si=_3pVDTTcjIvHLuUB",
        pdf: null,
      },
      {
        title: "Llegaste a mí",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/hJvrtMNjOnk?si=aK35fYSWAVdxnm_O",
        pdf: null,
      },
      {
        title: "Gracias, Dios",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/jX9-lo8wJPQ?si=FxnHnFOlmQMdUp3o",
        pdf: null,
      },
      {
        title: "La luz",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/OW27xvokYh0?si=ZItNL0woxARm1BST",
        pdf: null,
      },
      {
        title: "Derrama tu fuego",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/LuCRvA0kMb8?si=m8w097PjuqTSg4il",
        pdf: null,
      },
      {
        title: "Jesús",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/O2dSAyxt2mk?si=t1kO1mZLJ39mxdF7",
        pdf: null,
      },
      {
        title: "Digno eres tú",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/SGQo1W61OXU?si=DAAQ3e7NVoibUK6p",
        pdf: null,
      },
      {
        title: "Baila a mi lado",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/9-CNlCk0_NA?si=JkDGzL2wnDVParT3",
        pdf: null,
      },
      {
        title: "No me rindo",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/52zOznyYqVs?si=T3LjIMZne0kHl9i_",
        pdf: null,
      },
      {
        title: "No me dejarás",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/gDctjb3AWi8?si=TieX3I7z1zHQB9aJ",
        pdf: null,
      },
      {
        title: "La batería",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/6u_hPr3hT1w?si=B7iGo47nTeFmaIEz",
        pdf: null,
      },
    ],
  },
  {
    id: 6,
    nameAlbum: "Navidad, Vol. 3",
    year: "2020",
    totalSongs: "7",
    image: DiscographyImages.NavidadVol3,
    urlMultitrack: "https://bfan.link/navidad-vol-3",
    songs: [
      {
        title: "Todo brilla",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/79NXoM1TNOg?si=rboxYUypiRMy9WNo",
        pdf: null,
      },
      {
        title: "Se Oye un canto en alta esfera (Bonus track) [live]",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/f7Em3MWZHGc?si=nOlkxkF0duKaTTck",
        pdf: null,
      },
      {
        title: "Tú eres la luz noche de paz (Bonus track) [live]",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/BVUEXCAdLrU?si=WvOUUJuJBRX_LkMK",
        pdf: null,
      },
      {
        title: "Venid fieles todos (Bonus track) [live]",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/8kqNGTq8AoE?si=2kKKRtPOZCWDD370",
        pdf: null,
      },
      {
        title: "Aleluya",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/8pFuLtFqMh8?si=0J8upgmBQ8zq55s4",
        pdf: null,
      },
      {
        title: "Una noche sin igual",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/SupA2NwYUzE?si=sS7NkUh38ue0RqTw",
        pdf: null,
      },
      {
        title: "La tierra canta",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/cjRp7EdMsDg?si=4DpEjC9yzLrWy-JU",
        pdf: null,
      },
    ],
  },
  {
    id: 7,
    nameAlbum: "El cielo en la tierra (Pianos para Orar)",
    year: "2020",
    totalSongs: "10",
    image: DiscographyImages.ElCieloEnLaTierra,
    urlMultitrack: null,
    songs: [
      {
        title: "Paz - Piano",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/AzIjMgb15-U?si=5GHO6MVWdYTGLnln",
        pdf: null,
      },
      {
        title: "Gozo - Piano",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/bQppmpv88i8?si=lRZanjaoSCmJZv17",
        pdf: null,
      },
      {
        title: "Restauración - Piano",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/4Du4j8Wi0Yw?si=IHVSo_9vA9gJLGKc",
        pdf: null,
      },
      {
        title: "Fe - Piano",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/EmSVzPqSE_g?si=NdDDyKvm7XUBMjoT",
        pdf: null,
      },
      {
        title: "Arrepentimiento - Piano",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/a97peM_UffY?si=hvD-7DDKRZIMpE4v",
        pdf: null,
      },
      {
        title: "Sanidad - Piano",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/2ZQw7EPWf9c?si=AU5tzzNiShZ7nPti",
        pdf: null,
      },
      {
        title: "Espíritu Santo - Piano",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/192YjnkqplI?si=0FX5CR7z3MKRs5Rf",
        pdf: null,
      },
      {
        title: "Libertad - Piano",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/doLLcF0JKU0?si=qVvRsFSuEJs_EA7x",
        pdf: null,
      },
    ],
  },
  {
    id: 8,
    nameAlbum: "Fragmentos del cielo",
    year: "2018",
    totalSongs: "16",
    image: DiscographyImages.FragmentosDelCielo,
    urlMultitrack: null,
    songs: [
      {
        title: "Alegras mis días",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/CF4K43i3j_g?si=0l8nsCYz1JXsUnbF",
        pdf: null,
      },
      {
        title: "Eternamente amor",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/apT2MbWd72o?si=yZc8xK9FM1PV3YFd",
        pdf: null,
      },
      {
        title: "Fragmentos del cielo",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/GfyHetspMkk?si=0sTxFqQFA8uwwzTJ",
        pdf: null,
      },
      {
        title: "Mi roca",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/tFIboQ9VLgc?si=GeC7KfK_by1jxruo",
        pdf: null,
      },
      {
        title: "Maestro de milagros",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/4KAPOdmmNCg?si=ITg531ZCvG8EUTS2",
        pdf: null,
      },
      {
        title: "Dios de gloria",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/3cE0FDK7e8g?si=fmifbG803hsGbF5l",
        pdf: null,
      },
      {
        title: "Lluvia de tu gracia",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/IyBVY1c6aPI?si=SJbCBVN8F_G206GE",
        pdf: null,
      },
      {
        title: "Getsemaní",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/CLEYTNc1o2Q?si=mrb0_zW0UAfKwWXI",
        pdf: null,
      },
      {
        title: "Pegaíto - Remix",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/10GFchqZ64k?si=BK_89Azc12H1wdQB",
        pdf: null,
      },
      {
        title: "Me has sanado",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/W3-h6F6oY1U?si=xfLJlEGaOOq-sLre",
        pdf: null,
      },
      {
        title: "Veo al hijo del hombre",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/XoJyL6HiIVE?si=T2Gdg5iNpmmud6tb",
        pdf: null,
      },
      {
        title: "Dices de mí",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/rvvPc_s644s?si=6-0ELWDKNaqO8oO4",
        pdf: null,
      },
      {
        title: "Escondite seguro",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/VK_Sdm7S_qA?si=qnUucW8TtdojSOOT",
        pdf: null,
      },
      {
        title: "Bailando",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/TAp3LcgH1WU?si=Zbl3WCyAe6EhC12J",
        pdf: null,
      },
      {
        title: "Mi cita del cielo",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/riPWJRCn9V8?si=FYdcP8DkJdJUWT5r",
        pdf: null,
      },
    ],
  },
  {
    id: 9,
    nameAlbum: "Vive en mí",
    year: "2015",
    totalSongs: "13",
    image: DiscographyImages.ViveEnMi,
    urlMultitrack: null,
    songs: [
      {
        title: "Soy libre",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/XQmftyqCdMs?si=eqi-UBCiYwYv0vgo",
        pdf: null,
      },
      {
        title: "Voy a surfear",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/6L4tUjILWGQ?si=U2pD2cgpS90v9OZW",
        pdf: null,
      },
      {
        title: "En tu majestad",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/aeQJOszTkYE?si=3WuvTlSw0iohOJ8y",
        pdf: null,
      },
      {
        title: "No hay nadie como tú",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/38Qf9ctakwM?si=HuQ37EkP0GiaUQId",
        pdf: null,
      },
      {
        title: "Mi tesoro eres tú",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/r1pbM6uGHiw?si=-eITFyvG7WwK1LD_",
        pdf: null,
      },
      {
        title: "Pintas el aire",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/-J-pB4SFlMI?si=jSEml3hbERU7ENqH",
        pdf: null,
      },
      {
        title: "Vive en mi",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/bXyREpsFWdk?si=LAmuftUNxSBUq2_s",
        pdf: null,
      },
      {
        title: "Te amo a ti",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/H0aM1qk4DOM?si=E1UVx14LrkGuRxuc",
        pdf: null,
      },
      {
        title: "Solo estar ahí",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/QEX_Zh27yHM?si=DVx8wN19jJQmVaRz",
        pdf: null,
      },
      {
        title: "Cerca de mí",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/fPPkTBZWFv8?si=30l5ZlLNrKlyDOkP",
        pdf: null,
      },
      {
        title: "He caminado sobre el mar",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/GQm3i3j0vWM?si=SoTasQcMz-LfeKfg",
        pdf: null,
      },
      {
        title: "Soy tu padre",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/IVRT4raCbNY?si=zMHRWRN_5bmEdKvG",
        pdf: null,
      },
      {
        title: "Just to be there",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/PZRsDNGapxA?si=gc0fD8eKDMgKzRKX",
        pdf: null,
      },
    ],
  },
  {
    id: 10,
    nameAlbum: "Himnos",
    year: "2014",
    totalSongs: "10",
    image: DiscographyImages.Himnos,
    urlMultitrack: null,
    songs: [
      {
        title: "Maravilloso es El",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/yKsjXZTUmWQ?si=3Fn0DKok7tlLc6xX",
        pdf: null,
      },
      {
        title: "Solo de Jesús la sangre",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/aLU_u0Ss4Vc?si=X2G_OiWAaF688yXZ",
        pdf: null,
      },
      {
        title: "El corazón de la adoración",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/d8gez4lcsYo?si=yLUquS0oRR7ruSio",
        pdf: null,
      },
      {
        title: "Grande es tu fidelidad",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube: null,
        pdf: null,
      },
      {
        title: "Pon tus ojos en Cristo",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/noHS41V7AK4?si=UUUHo-U33CbIURfQ",
        pdf: null,
      },
      {
        title: "Oh amor de Dios",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/JvXn6vhPBHw?si=16PESUoaRI9yWG1A",
        pdf: null,
      },
      {
        title: "Me ha tocado",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/8oqBN3Ermdo?si=2tvqlL3zJwjUgXpf",
        pdf: null,
      },
      {
        title: "Yo me rindo a Él",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/OA18dggcT2w?si=B-QjjFVFw7sq75DN",
        pdf: null,
      },
      {
        title: "10.000 Razones",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/-UuGyqlEVBI?si=CPfjAw0JURZJKDwb",
        pdf: null,
      },
      {
        title: "Cuan grande es Él",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/cLWmkfhs9aI?si=iyQuFyR9lZ80Y8EL",
        pdf: null,
      },
    ],
  },
  {
    id: 11,
    nameAlbum: "Fiel",
    year: "2013",
    totalSongs: "13",
    image: DiscographyImages.Fiel,
    urlMultitrack: "https://bfan.link/fiel-1",
    songs: [
      {
        title: "Canta sobre mí",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/_lAryDQ-MiM?si=MIBBJUweuimb-4i_",
        pdf: null,
      },
      {
        title: "Dios fiel",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/plXAGmzcow0?si=-mGviRfBCunZ2Q32",
        pdf: null,
      },
      {
        title: "Fiel",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/vY0Ww5gvJ20?si=pRu8raoze38e7ACr",
        pdf: null,
      },
      {
        title: "El Héroe de la humanidad",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/H0eM_zOUpjA?si=XjUNh9y6Pi2VcX5I",
        pdf: null,
      },
      {
        title: "Eterna relación",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/aQUEaRoupRA?si=n0JNEZKye6iBRrP5",
        pdf: null,
      },
      {
        title: "Al Rey de los cielos",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/86yzuniUqcc?si=DbrkgmpaZpqQNrEY",
        pdf: null,
      },
      {
        title: "La voz del señor",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/QrJ-KL-v_A0?si=qOmE_8TZiGwl0Y_U",
        pdf: null,
      },
      {
        title: "El centro de mi ser",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/MBBKXDGJ9eA?si=4ivemw7b0PsCZ0zl",
        pdf: null,
      },
      {
        title: "Cristo vive en mí",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/KhqpBt3UuxU?si=NRJ06BuOwLnw2QL1",
        pdf: null,
      },
      {
        title: "En tus ojos",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/Ft5uXb_1RcQ?si=kCF_EVHv1pntQweD",
        pdf: null,
      },
      {
        title: "Por la abundancia",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/yn5uiZzxmnU?si=YvpyHg4CftGMmpeP",
        pdf: null,
      },
      {
        title: "Preciosa mía",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/_xjxl9a3DH4?si=GBnIjDt4M3ZWXA28",
        pdf: null,
      },
      {
        title: "Fiesta",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/VSeeBfYmkTY?si=r1Yp9KZ6l8RV2mAf",
        pdf: null,
      },
    ],
  },
  {
    id: 12,
    nameAlbum: "Bichos Freak con Alex Campos",
    year: "2012",
    totalSongs: "10",
    image: DiscographyImages.BichosFreak,
    urlMultitrack: null,
    songs: [
      {
        title: "Eres",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/AMKQU6U7Hnk?si=-C2CSM-FYKZPmcs5",
        pdf: null,
      },
      {
        title: "Goliat",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/wTSgmbvB4UQ?si=wVBT5_G15HP1qpFK",
        pdf: null,
      },
      {
        title: "El cielo en la tierra",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/xJt0NEzKwws?si=zMuXoh4JFPZXhmHT",
        pdf: null,
      },
      {
        title: "Fuego",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/8z_x0VnahvE?si=B8jALi7VQ8HkbbbB",
        pdf: null,
      },
      {
        title: "Hosanna",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/wvbs3PTlfUM?si=dSwrDV7fvApXOora",
        pdf: null,
      },
      {
        title: "Al gran yo soy",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/vdJjBRDRlzo?si=-ezngiNbGYt0rJ0v",
        pdf: null,
      },
      {
        title: "Me dijo (feat. Bichos Freak)",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/hUrhNmmzF0Y?si=nzDz4c21L8wVoLdF",
        pdf: null,
      },
      {
        title: "Cuidare de tí (feat. Bichos Freak)",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/ldNYAsvnYUo?si=A8dbjFjMNpra7gDo",
        pdf: null,
      },
      {
        title: "Dios creó (feat. Bichos Freak)",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/afTrWG5aoGc?si=2VQgQCXPyU_rGeLa",
        pdf: null,
      },
      {
        title: "Manos en alto (feat. Bichos Freak)",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/i5TSsKo5FRA?si=F7WZrwvleQrW2Ajk",
        pdf: null,
      },
    ],
  },
  {
    id: 13,
    nameAlbum: "Él",
    year: "2011",
    totalSongs: "13",
    image: DiscographyImages.El,
    urlMultitrack: null,
    songs: [
      {
        title: "Eres",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/XdfXHgMe4Cs?si=xOXI4fR_i4o9-8wI",
        pdf: null,
      },
      {
        title: "Cámbiame",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/6CuaHY9gLKo?si=ofk13KlkmeZ0P5D9",
        pdf: null,
      },
      {
        title: "Sublime Dios",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/TpVadL0_LtM?si=wmXtQRJbfeIu6min",
        pdf: null,
      },
      {
        title: "Glorioso Rey",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/vGmneeMVebo?si=JLrw_2KfKFO9RDdZ",
        pdf: null,
      },
      {
        title: "Levántate",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/k1G-K2E-Rvc?si=dZU1cuGssZx3mzPp",
        pdf: null,
      },
      {
        title: "Admirable amor",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/WK_4z2ljGLs?si=t7DZbQVMVwhKakJE",
        pdf: null,
      },
      {
        title: "Gracias",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/eMg0ix_OhGk?si=SYXnq405aJby3udY",
        pdf: null,
      },
      {
        title: "Eres la luz",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/ZikrNXvyDfQ?si=568k2gsU4jOqWgkp",
        pdf: null,
      },
      {
        title: "Espíritu santo",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/qpkCb9fxigE?si=f-aK45bEws6lbyZR",
        pdf: null,
      },
      {
        title: "Hosanna",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/6-E3AyGzUB8?si=VfKITotx60PFXAQP",
        pdf: null,
      },
      {
        title: "Al Dios eterno",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/12IXCRKxgU0?si=mNhrF2BTJTn6Xu9J",
        pdf: null,
      },
      {
        title: "Al gran yo soy",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/7SWGLgNsD70?si=MUUkyV3pSvx8eL1b",
        pdf: null,
      },
      {
        title: "Fuego",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/Mjyv8oLojZ4?si=-lOjAl59NlG6-3ZA",
        pdf: null,
      },
    ],
  },
  {
    id: 14,
    nameAlbum: "Jesús Freak",
    year: "2009",
    totalSongs: "13",
    image: DiscographyImages.JesusFreak,
    urlMultitrack: null,
    songs: [
      {
        title: "Goliat",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/PehlNx2bpcI?si=ukMyLNk9FDHLeKy6",
        pdf: null,
      },
      {
        title: "El reino",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/ShqHzD9qVmA?si=PGsPhKnwYKY5Ejdi",
        pdf: null,
      },
      {
        title: "Jesús Freak",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/xfeLcmAAQF0?si=pOghZ6IgsdpxpI7K",
        pdf: null,
      },
      {
        title: "Estrella de la mañana",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/VuOxQ2_8CmE?si=uWxUwl-vQGkaYZeD",
        pdf: null,
      },
      {
        title: "Conoceré",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/bGVIloLR_0M?si=ODpugPLQsBpx8Hlu",
        pdf: null,
      },
      {
        title: "Perdóname",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/p63p6gTbUb8?si=hL3NNiEmm6hKK2wi",
        pdf: null,
      },
      {
        title: "Como las estrellas",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/jncQZS9aih0?si=QR-QkSQco7Zuyf1-",
        pdf: null,
      },
      {
        title: "El cielo en la tierra",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/j22hghkpmVs?si=Om7s9yFXHO0WIIMM",
        pdf: null,
      },
      {
        title: "Conocerte es amarte",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/IYpgNZPO3xM?si=Cciah6dblIDKfn8d",
        pdf: null,
      },
      {
        title: "Plantado",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/c9P8n6gXqPo?si=pd33C04F2rh8IpgB",
        pdf: null,
      },
      {
        title: "Contigo soy feliz",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/pkL1LwK32tE?si=LHqa0WKuXrxJ8QKB",
        pdf: null,
      },
      {
        title: "Reina",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/dg0dpjIc994?si=pn24Wb73V8uJUOw1",
        pdf: null,
      },
      {
        title: "Yo te necesito",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/5i6ffJALth0?si=ZOdkHr_HpH_QX5Ud",
        pdf: null,
      },
    ],
  },
  {
    id: 15,
    nameAlbum: "Cielos abiertos",
    year: "2007",
    totalSongs: "11",
    image: DiscographyImages.CielosAbiertos,
    urlMultitrack: "https://bfan.link/cielos-abiertos",
    songs: [
      {
        title: "Abre tus cielos - En vivo",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/9LFCz6B1zR4?si=1jhjvZu7XnxBeNsn",
        pdf: null,
      },
      {
        title: "Todo lo bueno - En vivo",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/QEQVXRjlWLk?si=SzeG7PADnvx669dm",
        pdf: null,
      },
      {
        title: "La cima - En vivo",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/pWP1d3LhwLc?si=sayKwo6Abheg0RW9",
        pdf: null,
      },
      {
        title: "Como un trueno - En vivo",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/FniQ0W7GnVQ?si=joS3xlVbfOzpiXRE",
        pdf: null,
      },
      {
        title: "Cerca de mí - En vivo",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/xCcjRgBDSPs?si=ke_4BTKJfyOOXOzf",
        pdf: null,
      },
      {
        title: "Los colores - En vivo",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/DfveI8FO4uQ?si=JB6ZUpyTxBHJ2f-E",
        pdf: null,
      },
      {
        title: "Pegaito - En vivo",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/GZeNKvi7ePo?si=4z6dCPZsQTUhQt5L",
        pdf: null,
      },
      {
        title: "Toda nación - En vivo",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/OzPqyoo0cNg?si=TkQNIJXFRG2GhC_d",
        pdf: null,
      },
      {
        title: "En cada sonido - En vivo",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/PJiy7_JeL6A?si=BJbT670poJopDfvU",
        pdf: null,
      },
      {
        title: "Salmo 145 - En vivo",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/6jhfjVbSWYM?si=oz0ZA8IoEU9UCOdL",
        pdf: null,
      },
      {
        title: "Tú solo tú - En vivo",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/pS_zkDYv7_k?si=kbtJvKCjnBp_9OZy",
        pdf: null,
      },
    ],
  },
  {
    id: 16,
    nameAlbum: "Voy buscando",
    year: "2005",
    totalSongs: "12",
    image: DiscographyImages.VoyBuscando,
    urlMultitrack: null,
    songs: [
      {
        title: "Entre el perfume",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/YTEyigns0QQ?si=qRq2cyDL9lfslbfc",
        pdf: null,
      },
      {
        title: "A bailar",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/Ya7E39f_wfg?si=PLQ6sDIzWaAAevB0",
        pdf: null,
      },
      {
        title: "Siempre estarás",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/LlqC9t9H6zE?si=Uy0N04KbHA--wcVd",
        pdf: null,
      },
      {
        title: "Yo te magnifico",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/zje0z-SYnsk?si=AwaeYSNt9hhDYDTt",
        pdf: null,
      },
      {
        title: "Voy buscando",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/X3il5KlXSYQ?si=h5rsqpWv2Lxqx2_v",
        pdf: null,
      },
      {
        title: "En el desiento - Un canto de amor",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/o1sP4yO8ns8?si=5F4GIBPt01q4TRlI",
        pdf: null,
      },
      {
        title: "Tu vida Cambiará",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/FRgDdl_NmvU?si=enJS2-5c5OpPpOqm",
        pdf: null,
      },
      {
        title: "Tu vida diste por mí",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/3ZwYynyxrAA?si=CZYiFj_8XKdiEdnm",
        pdf: null,
      },
      {
        title: "Coronado",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/tr4gjx9rScY?si=TtVDD7zQk-N2VEPD",
        pdf: null,
      },
      {
        title: "Mi amor hacia tí",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/xBRne4S9HuQ?si=7RE1ZrQMC8pB7yVq",
        pdf: null,
      },
      {
        title: "Conocerte más",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/DnzbieX0cdU?si=Xh1a-DkskvQmchK2",
        pdf: null,
      },
      {
        title: "Solo te diré",
        tono: null,
        compas: null,
        tempo: null,
        urlYoutube:
          "https://www.youtube.com/embed/oAMbTXsIFFI?si=Y-Qqy2G2S99jXLD6",
        pdf: null,
      },
    ],
  },
];
